import { animate, style, transition, trigger } from '@angular/animations';

export const fadeOutAnimation = trigger('fadeOutAnimation', [
  transition('* => void', [animate(100, style({ opacity: '0' }))])
]);
